import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthService implements CanActivate {
  user: Observable<firebase.User>;

  constructor(private firebaseAuth: AngularFireAuth,
    private router: Router,
    private _localStorageService: LocalStorageService) {
    this.user = firebaseAuth.authState;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this._localStorageService.retrieve('userDetails')) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  signup(email: string, password: string) {
    this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(email, password)
      .then(value => {
      })
      .catch(err => {
      });
  }

  checkPassword(cpassword, npassword): Promise<void> {
    const user = this.firebaseAuth.auth.currentUser;
    const credentials: any = firebase.auth.EmailAuthProvider.credential('superadmin@oros.com', cpassword);
    return user.reauthenticateWithCredential(credentials)
      .then(() => {
        return true;
      })
      .catch(err => {
        return err;
      });
  }

  changePassword(npassword): Promise<void> {
    const user = this.firebaseAuth.auth.currentUser;
    return user.updatePassword(npassword).then(function () {
    }).catch(function (val) {
      return val;
    });
  }

  login(email: string, password: string): Promise<void> {
    return this.firebaseAuth
      .auth
      .signInWithEmailAndPassword(email, password)
      .then(value => {
        return Promise.resolve(value);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  logout(): Promise<void> {
    return this.firebaseAuth
      .auth
      .signOut().then(value => {
        return Promise.resolve(value);
      })
      .catch(err => {
        return Promise.reject(err);
      });;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts